export default __webpack_public_path__ + "static/En_EFTB_iMedical_Declaration-1a8b759ba7185990df01cdf87f70a763.pdf";